export default __webpack_public_path__ + "static/media/Product-Making_Charge.9fc11036.jpg";